import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useEvents(params, refetch = 30000) {
  return useQuery({
    queryKey: ["events", params],
    queryFn: () => api.get("/events", { params }).then((r) => r.data),
    refetchInterval: refetch,
  });
}
